export default __webpack_public_path__ + "static/media/planian_logo.693a1257.svg";